module.exports = __webpack_public_path__ + "static/media/pre.72674ce3.svg";